import axios from '../api/axios';

export default {
    getPushList({params, callback}){ // 列表
        axios.post(`/v1/admin/list`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    addPush({params, callback}){ 
        axios.post(`/v1/admin/add`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    getVenueList({params, callback}){ 
        axios.post(`/v1/admin/venueSelect`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    delPush({params, callback}){ 
        axios.delete(`/v1/admin/delete/${params.pushId}`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/push.js